import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const mckessonApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMckessonVendorDetail: builder.mutation({
      query: () => ({
        url: `/mckesson/getvendordetail`,
        method: "GET",
      }),
    }),
    getMckessonShippingLocations: builder.mutation({
      query: () => ({
        url: `/mckesson/getshippinglocations`,
        method: "GET",
      }),
    }),
    getMckessonApis: builder.mutation({
      query: () => ({
        url: `/mckesson/getapis`,
        method: "GET",
      }),
    }),
    postMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postapi`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putapi`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteapi?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    postMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postvendordetail`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putvendordetail`,
        method: "PUT",
        body: data,
      }),
    }),
    postMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postshippinglocation`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putshippinglocation`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteshippinglocation?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    getMckessonEdiFileList: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessonedifilelist?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonOrderFiles: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/files?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonEdiItemList: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessoneditemlist?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonEdiHeaderList: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessonediheaderlist?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonOrderDataItems: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/dataitems?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    fetchMckessonOrderItem: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/fetch?${getFilters(data)}`,
        method: "POST",
        body: data,
      }),
    }),
    markMckessonOrderProcessed: builder.mutation({
      query: (data) => ({
        url: `/mckesson/orderprocessor/markprocessed`,
        method: "PUT",
        body: data,
      }),
    }),
    getMckessonItems: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessonitems?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getMckessonUoms: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getmckessonuoms?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    postMckessonItemSearch: builder.mutation({
      query: ({ persist, ...data }) => ({
        url: `/mckesson/itemsearch${persist !== undefined ? `?persist=${persist}` : ""}`,
        method: "POST",
        body: data,
      }),
    }),
    postMckessonItemFeed: builder.mutation({
      query: ({ persist, ...data }) => ({
        url: `/mckesson/itemfeed${persist !== undefined ? `?persist=${persist}` : ""}`,
        method: "POST",
        body: data,
      }),
    }),
    postMckessonItemLookup: builder.mutation({
      query: ({ itemId, persist }) => ({
        url: `/mckesson/itemlookup?itemId=${itemId}${persist !== undefined ? `&persist=${persist}` : ""}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetMckessonVendorDetailMutation,
  useGetMckessonShippingLocationsMutation,
  useGetMckessonApisMutation,
  usePostMckessonApiMutation,
  usePutMckessonApiMutation,
  useDeleteMckessonApiMutation,
  usePostMckessonVendorDetailMutation,
  usePutMckessonVendorDetailMutation,
  usePostMckessonShippingLocationMutation,
  usePutMckessonShippingLocationMutation,
  useDeleteMckessonShippingLocationMutation,
  useGetMckessonEdiFileListMutation,
  useGetMckessonEdiItemListMutation,
  useGetMckessonEdiHeaderListMutation,
  useGetMckessonOrderFilesMutation,
  useGetMckessonOrderDataItemsMutation,
  useFetchMckessonOrderItemMutation,
  useMarkMckessonOrderProcessedMutation,
  useGetMckessonItemsMutation,
  useGetMckessonUomsMutation,
  usePostMckessonItemSearchMutation,
  usePostMckessonItemFeedMutation,
  usePostMckessonItemLookupMutation,
} = mckessonApiSlice;
